import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import BigCalendar from './BigCalendar';
import { Actions } from '../../../../client/Actions';
import CustomCard from '../../CustomCard'; // lub '../calendar/BigCalendar' jeśli trzymasz go osobno

const HouseCalendar = ({ houseId }) => {
  const [reservations, setReservations] = useState();
  const [blockedDays, setBlockedDays] = useState();
  const [bookingBlockedDays, setBookingBlockedDays] = useState();

  function loadReservations() {
    Actions.get('reservation/house/' + houseId, setReservations);
  }

  function loadBlockedDays() {
    Actions.get('blocked-days', (res) =>
      setBlockedDays(res.filter((bd) => bd.house?.id == houseId)),
    );
  }

  function loadBookingBlockedDays() {
    Actions.get('booking-blocked-days', (res) =>
      setBookingBlockedDays(
        (res || [])
          .filter((bd) => bd.house?.id == houseId)
          .map((bd) => ({
            ...bd,
            bookingBlock: true,
          })),
      ),
    );
  }

  useEffect(() => {
    loadReservations();
    loadBlockedDays();
    loadBookingBlockedDays();
  }, [houseId]);

  if (!reservations || !blockedDays || !bookingBlockedDays) return <></>;

  return (
    <CustomCard withoutHeader={true} width={12} shadow={false} className="mb-0">
      <Card.Text className="text-muted my-0">
        <BigCalendar
          views={['month']}
          height={'70vh'}
          reservations={reservations}
          blocked={[...blockedDays, ...bookingBlockedDays]}
        />
      </Card.Text>
    </CustomCard>
  );
};

export default HouseCalendar;
